import React, { FC } from "react"
import { Redirect, RouteComponentProps } from "react-router"
import { AuthCheck } from "../../../Components/Common/AuthCheck/AuthCheck"
import { Loader } from "dash-styled"
import { selectUser } from "../../../Helpers/Functions/Selectors/auth"
import { useAppState } from "../../../Hooks/useReduxState"

export const DashboardHomeRoute: FC<RouteComponentProps> = props => {
    const user = useAppState(selectUser)

    return (
        <AuthCheck>
            {user === undefined ? (
                <Loader />
            ) : (
                <Redirect
                    to={`${props.location.pathname.replace(
                        /\/dashboard/,
                        `/u/${user.username}`
                    )}${props.location.search}`}
                />
            )}
        </AuthCheck>
    )
}
